module.exports = __webpack_public_path__ + "img/Member-None.61c28a0b.svg";